import { isProduction } from "./checkEnv";

const TOKEN_DEV = "fc1de56836d2a7193ac46f313e5867dd";
const TOKEN_PROD = "20e6f1eb13fa9dbbb51e8e531cb7c200";

export const getMixpanelToken = () => {
  const isProd = isProduction();
  if (!isProd) {
    console.log(`Using Mixpanel's development token!`);
  }
  return isProd ? TOKEN_PROD : TOKEN_DEV;
};
